(function () {
  const MOBILE_MQ = '(max-width: 720px)';
  const AUTOPLAY_MS = 5000;

  function initCarousel(root) {
    if (root.dataset.ingredientsCarouselInit === 'true') return;
    root.dataset.ingredientsCarouselInit = 'true';

    const slides = Array.from(root.querySelectorAll('.ing-item'));
    if (!slides.length) return;

    let index = 0;
    let timer = null;
    const mediaQuery = window.matchMedia(MOBILE_MQ);

    function show(activeIndex) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
        slide.setAttribute('aria-hidden', i === activeIndex ? 'false' : 'true');
      });
      updateDots(activeIndex);
    }

    function buildDots() {
      let dots = root.querySelector('.ing-carousel__dots');
      if (slides.length < 2) {
        if (dots) dots.remove();
        return;
      }
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'ing-carousel__dots';
        dots.setAttribute('role', 'tablist');
        dots.setAttribute('aria-label', 'Ingredients');
        root.appendChild(dots);
      }
      dots.innerHTML = '';
      slides.forEach((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ing-carousel__dot';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', `Ingredient ${i + 1} of ${slides.length}`);
        btn.addEventListener('click', () => {
          index = i;
          show(index);
          restartAutoplay();
        });
        dots.appendChild(btn);
      });
    }

    function updateDots(activeIndex) {
      const dots = root.querySelectorAll('.ing-carousel__dot');
      dots.forEach((dot, i) => {
        const isActive = i === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!mediaQuery.matches || slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      timer = setInterval(() => {
        index = (index + 1) % slides.length;
        show(index);
      }, AUTOPLAY_MS);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function applyMode() {
      buildDots();

      if (mediaQuery.matches) {
        show(index);
        startAutoplay();
      } else {
        stopAutoplay();
        slides.forEach((slide) => {
          slide.classList.remove('is-active');
          slide.removeAttribute('aria-hidden');
        });
      }
    }

    mediaQuery.addEventListener('change', () => {
      index = 0;
      applyMode();
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    applyMode();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ingredients-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
